import translations from '../translations.js';
import Api from "../api.js";
import $ from "../util/dom.js";
import {cleanString} from "../util.js";
let TranslationService = (()=>{
    let me = {};
    let cacheMap = {};
    let reversed = {};
    let useTranslationService = false;

    me.translate = async (key,fromLan,toLan)=>{
        if (translations[key]){
            return translations[key];
        }
        let cache = cacheMap[fromLan + "_" + toLan];
        if (!cache){
            cache = {};
            cacheMap[fromLan + "_" + toLan] = cache;
        }
        if (cache[key]){
            console.log("Returning from cache");
            return cache[key];
        }

        if (useTranslationService){
            let result = await Api.translate(key,fromLan,toLan);
            cache[key] = result;
            return result;
        }else{
            return key;
        }

    }

    me.box = (text,src,target)=>{
        if (!useTranslationService){
            return text;
        }

        let elm;
        let button;
        if (src === target) return $(".text",text);
        let isTranslated = false;

        return $(".translatebox",elm = $(".text",text),button = $(".button",{onClick:()=>{
            if (isTranslated){
                elm.innerHTML = "";
                elm.innerText = text;
                isTranslated = false;
            }else{
                elm.innerHTML = "";
                elm.appendChild($(".spinner"));
                me.translate(text,src,target).then(result=>{
                    if (result.result){
                        elm.innerHTML = "";
                        elm.innerText = result.result;
                    }else{
                        elm.innerText = result;
                    }
                    isTranslated = true;
                    button.innerText = "Show original";
                });
            }
            }},"Translate to " + target.toUpperCase()));
    }

    me.map = value=>{
        let result = translations[cleanString(value)];
        if (result){
            reversed[result] = value;
            return result;
        }
        if (value.indexOf("(")>0){
            let parts = value.split("(");
            let key = cleanString(parts[0].trim());
            let val = parts[1].trim();
            if (val.endsWith(")")){
                val = val.substring(0,val.length-1).trim();
            }
            result = translations[key] || key;
            let tVal = translations[cleanString(val)] || val;
            result = result + " (" + tVal + ")";
            reversed[result] = value;
            return result;
        }
        return value;
    }

    me.reverse = value=>{
        if (reversed[value]) return reversed[value];
        for (let key in translations){
            if (translations[key] === value) return key;
        }
        return value;
    }

    return me;
})();

export default TranslationService;